import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import RouteGuard from './RouteGuard';

const HomePage = lazy(() => import('../pages/home/page'));
const LoginPage = lazy(() => import('../pages/auth/login'));
const RegisterPage = lazy(() => import('../pages/auth/register'));
const ForceResetPasswordPage = lazy(() => import('../pages/auth/force-reset-password'));
const ApplicationPage = lazy(() => import('../pages/application/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const UploadWorkPage = lazy(() => import('../pages/upload-work/page'));
const ExpertPage = lazy(() => import('../pages/expert/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const SetupPage = lazy(() => import('../pages/admin/setup'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const RegistrationClosedPage = lazy(() => import('../pages/registration-closed/page'));

const withRoleGuard = (
  element: React.ReactElement,
  allowedRoles?: Array<'ADMIN' | 'EXPERT' | 'APPLICANT'>,
  requireAuth = false,
) => (
  <RouteGuard
    allowedRoles={allowedRoles}
    requireAuth={requireAuth || !!allowedRoles?.length}
  >
    {element}
  </RouteGuard>
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/register',
    element: <RegisterPage />,
  },
  {
    path: '/force-reset-password',
    element: withRoleGuard(<ForceResetPasswordPage />, undefined, true),
  },
  {
    path: '/auth/force-reset-password',
    element: withRoleGuard(<ForceResetPasswordPage />, undefined, true),
  },
  {
    path: '/dashboard',
    element: withRoleGuard(<DashboardPage />, ['APPLICANT']),
  },
  {
    path: '/application',
    element: withRoleGuard(<ApplicationPage />, ['APPLICANT']),
  },
  {
    path: '/upload-work',
    element: withRoleGuard(<UploadWorkPage />, ['APPLICANT']),
  },
  {
    path: '/expert',
    element: withRoleGuard(<ExpertPage />, ['EXPERT']),
  },
  {
    path: '/admin',
    element: withRoleGuard(<AdminPage />, ['ADMIN']),
  },
  {
    path: '/admin/setup',
    element: withRoleGuard(<SetupPage />, ['ADMIN']),
  },
  {
    path: '/registration-closed',
    element: <RegistrationClosedPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
